module.exports = __webpack_public_path__ + "img/51626520_L.3e7fb112.png";